import React from "react";
import PropTypes from "prop-types";

import { replace } from "connected-react-router";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Icon from "@material-ui/core/Icon";
import ArrowForward from "@material-ui/icons/ArrowForward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import Loading from '../../components/Loading/Loading.jsx';
import Api from "../../api/Api.js";
import AuthEndpoints from "../../api/AuthEndpoints.js";
import NotificationModal from "../../components/Modal/NotificationModal.jsx";
import Success from "../../components/Typography/Success.jsx";
import { store } from "../../redux/store.js";

const newPasswordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*(){}[\\];:'\"\\\/|<>,.?`~\\-_ = +])(?=.*[0-9])(?=.*[a-z]).{8,64}$/

class SetNewPassword extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            password: '',
            retype: '',
            passwordInvalid: false,
            loading: false,
            success: false,
            error: false
        };
    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }

    async submitReset() {
        if (!this.state.password || !this.state.retype || this.state.password !== this.state.retype || !newPasswordRegex.test(this.state.password)) {
            this.setState({ passwordInvalid: true });
            return;
        }
        this.setState({ loading: true }, () => {
            //Request Reset
            const { reset_id } = this.props.match.params;

            Api.post(AuthEndpoints.setPassword, { new_password: this.state.password, token: reset_id })
                .then(({ data }) => {
                    if (data.valid) {
                        store.dispatch(replace('/login'));
                    } else {
                        this.setState({ loading: false, passwordInvalid: true });
                    }
                }).catch(() => {
                    this.setState({ loading: false, error: true });
                })
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={6} md={4}>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <Card login className={classes[this.state.cardAnimaton]}>
                                <CardHeader
                                    className={`${classes.cardHeader} ${classes.textCenter}`}
                                    color="rose"
                                >
                                    <h4 className={classes.cardTitle}>Set New Password</h4>
                                </CardHeader>
                                <CardBody>
                                    <CustomInput
                                        labelText={(this.state.passwordInvalid ? "Invalid New Password" : "New Password")}
                                        id="password"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Icon className={classes.inputAdornmentIcon}>
                                                        lock_outline
                                                    </Icon>
                                                </InputAdornment>
                                            ),
                                            type: "password",
                                            onChange: (event) => {
                                                const newPassword = event.target.value;
                                                this.setState({ password: newPassword, passwordInvalid: !newPassword || !newPasswordRegex.test(newPassword) });
                                            },
                                            onKeyPress: (e) => {
                                                if (e.key === 'Enter' && !this.state.passwordInvalid && this.state.retype === this.state.password) {
                                                    this.submitReset();
                                                }
                                            },
                                            value: this.state.password
                                        }}
                                        error={this.state.passwordInvalid}
                                    />
                                    {
                                        this.state.passwordInvalid ?
                                            <div>Must contain 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number.</div>
                                            :
                                            <div>&nbsp;</div>
                                    }

                                    <CustomInput
                                        labelText={(this.state.retype !== this.state.password && this.state.password && this.state.retype ? "Invalid Retyped Password" : "Retype Password")}
                                        id="retype"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Icon className={classes.inputAdornmentIcon}>
                                                        lock_outline
                                                    </Icon>
                                                </InputAdornment>
                                            ),
                                            type: "password",
                                            onChange: (event) => {
                                                this.setState({ retype: event.target.value });
                                            },
                                            onKeyPress: (e) => {
                                                if (e.key === 'Enter') {
                                                    this.submitReset();
                                                }
                                            },
                                            value: this.state.retype
                                        }}
                                        error={this.state.retype !== this.state.password && this.state.password && this.state.retype}
                                    />
                                </CardBody>
                                <CardFooter className={classes.justifyContentCenter}>
                                    {
                                        this.state.loading ?
                                            <div style={{ paddingBottom: 10 }}>
                                                <Loading />
                                            </div>
                                            :
                                            <Button key="reset" color="rose" simple size="lg" block disabled={this.state.passwordInvalid || this.state.retype !== this.state.password} onClick={() => this.submitReset()}>
                                                Change Password&nbsp;&nbsp;<ArrowForward />
                                            </Button>
                                    }
                                </CardFooter>
                            </Card>
                            <NotificationModal open={this.state.error} close={() => {
                                store.dispatch(replace('/requestReset'));
                            }}>
                                <Success><h3>Error!</h3></Success>
                                <p>
                                    The reset link you're using has expired.
                                </p>
                            </NotificationModal>
                        </form>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

SetNewPassword.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(SetNewPassword);
